{
  "background": {
    "background-default": "oklch(0.126543 0.006953 243.792325)",
    "background-subtle": "oklch(0.175228 0.006346 236.981786)"
  },
  "surface": {
    "surface-default": "oklch(0.175228 0.006346 236.981786)",
    "surface-raised": "oklch(0.269413 0.01036 242.083865)",
    "surface-sunken": "oklch(0.126543 0.006953 243.792325)"
  },
  "text": {
    "text-default": "oklch(0.970151 0 0)",
    "text-muted": "oklch(0.863097 0.007776 228.868893)",
    "text-subtle": "oklch(0.645222 0.009348 225.150438)",
    "text-inverse": "oklch(0.126543 0.006953 243.792325)",
    "text-link": "oklch(0.864091 0.092143 223.595164)"
  },
  "border": {
    "border-default": "oklch(0.348204 0.010712 236.894097)",
    "border-subtle": "oklch(0.269413 0.01036 242.083865)",
    "border-strong": "oklch(0.645222 0.009348 225.150438)"
  },
  "action": {
    "action-default": "oklch(0.719588 0.160232 241.934243)",
    "action-hover": "oklch(0.864091 0.092143 223.595164)",
    "action-subtle": "oklch(0.190403 0.080719 260.682766)"
  },
  "success": {
    "success-surface": "oklch(0.173455 0.059022 142.495345)",
    "success-text": "oklch(0.775209 0.103098 142.532525)",
    "success-border": "oklch(0.40526 0.136911 142.712023)",
    "success-solid": "oklch(0.604784 0.163709 142.769697)"
  },
  "warning": {
    "warning-surface": "oklch(0.18011 0.062518 35.437897)",
    "warning-text": "oklch(0.791422 0.092884 44.093664)",
    "warning-border": "oklch(0.431173 0.130695 40.89405)",
    "warning-solid": "oklch(0.634409 0.150779 43.925238)"
  },
  "danger": {
    "danger-surface": "oklch(0.161611 0.065248 23.141473)",
    "danger-text": "oklch(0.75077 0.106785 18.43901)",
    "danger-border": "oklch(0.374388 0.145685 19.336218)",
    "danger-solid": "oklch(0.565284 0.170522 18.2478)"
  },
  "info": {
    "info-surface": "oklch(0.137795 0.047857 264.580497)",
    "info-text": "oklch(0.676764 0.068234 261.470834)",
    "info-border": "oklch(0.331327 0.095363 262.195822)",
    "info-solid": "oklch(0.508435 0.109592 262.050185)"
  }
}
